import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Field from "../../../../../components/Field";
import Select from "../../../../../components/Inputs/Select";

export const manageAbilityOptions = [
  { value: "custom", label: "custom" },
  { value: "by-company", label: "By company" },
  { value: "by-location", label: "By locations" },
  { value: "all", label: "All" },
];

function ManageAbilitySelect({ form, values, disabled }) {
  const { t } = useTranslation();

  const onManageAbilityChange = useCallback(() => {
    form.setFieldsValue({
      companies: [],
      locations: [],
    });
  }, [form, values]);

  return (
    <Field name="manageAbility" label={t("manage-ability")}>
      <Select
        placeholder={t("manage-ability")}
        onChange={onManageAbilityChange}
        disabled={disabled}
      >
        {manageAbilityOptions.map(({ value, label }) => (
          <Select.Option key={value} value={value}>
            {t(label)}
          </Select.Option>
        ))}
      </Select>
    </Field>
  );
}

export default ManageAbilitySelect;
